import React from 'react';
import { AudienceType } from '../../../../../../models/FormProps';
import { StudentFormResponse, StaffFormResponse } from '../../Page';
import UntargetedStaffAudienceContent from './UntargetedStaffAudienceContent';
import UntargetedStudentAudienceContent from './UntargetedStudentAudienceContent';

interface Props {
  formAudience: AudienceType;
  responses: Array<StudentFormResponse | StaffFormResponse>;
  allowMultipleSubmissions: boolean;
}

export default function UntargetedAudienceContent(props: Props): React.ReactElement {
  const { formAudience, responses, allowMultipleSubmissions } = props;
  return (
    formAudience === AudienceType.UNTARGETED_STAFF
      ? (
        <UntargetedStaffAudienceContent responses={responses as Array<StaffFormResponse>} allowMultipleSubmissions={allowMultipleSubmissions} />
      )
      : (
        <UntargetedStudentAudienceContent responses={responses as Array<StudentFormResponse>} allowMultipleSubmissions={allowMultipleSubmissions} />
      )
  );
}
